// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__mSOMT","banner-content":"Banner_banner-content__Ly+eU","banner-text--underlined":"Banner_banner-text--underlined__C-obM","hidden":"Banner_hidden__gAouj"};